import React, { Component } from 'react'
import PropTypes from 'prop-types'
import QuantityEditor from './Tikex/QuantityEditor'

export default class Shortcode extends Component {
	render() {
		return (
			<QuantityEditor
				adSubPageId={this.props.wpObject.ad_sub_page_id}
				invoiceItemId={this.props.wpObject.invoice_item_id}
			/>
		)
	}
}

Shortcode.propTypes = {
	wpObject: PropTypes.object,
}
